import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';

import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import { Typography } from '@material-ui/core';

import DashboardService from '../../services/Dashboard';

export const Alertas = forwardRef(({ id }, ref) => {
    const [alertas, setAlertas] = useState([]);
    
    useImperativeHandle(ref, () => ({
        recarregar(id) {
            loadData(id);
        }
    }));

    const loadData = (id) => {
        const f = [{ field: 'id', value: id }];
        
        DashboardService.getAlertas(f)
            .then(res => setAlertas([...res.data]))
            .catch(() => null);
    }

    useEffect(() => {
        loadData(id);
    }, [id]);

    return (
        <>
            { alertas.length > 0 &&
                <Grid item xs={12} style={{ paddingBottom: '16px' }}>
                    { alertas.map(a =>
                        <Alert key={a.mensagem} severity={a.tipo} style={{ marginTop: '10px' }}>
                            <Typography variant="body1" dangerouslySetInnerHTML={{__html: a.mensagem}} />
                        </Alert>
                    )}
                </Grid>
            }
        </>              
    )
})

export default Alertas;